import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnchor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnchor1"><Path fillRule="evenodd" clipRule="evenodd" d="M12.7498 8.91949C14.3225 8.57621 15.5 7.17561 15.5 5.5C15.5 3.567 13.933 2 12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.17551 9.67733 8.57603 11.2498 8.91942V20.5H6.06354L3.74775 12.5H6.99985V11H1.75195L4.93616 22H19.0635L22.2477 11H16.9998V12.5H20.252L17.9362 20.5H12.7498V8.91949ZM10 5.5C10 4.39543 10.8954 3.5 12 3.5C13.1046 3.5 14 4.39543 14 5.5C14 6.60457 13.1046 7.5 12 7.5C10.8954 7.5 10 6.60457 10 5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnchor1;
